import React, { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import Select from 'react-select';
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'


export function useLanguageList() {
    const { t } = useTranslation();

    const languagesMap = useMemo(() => {
        return new Map([
            ['es', { label: t('editor.config.es'), value: 'es', description: t('editor.config.es') }],
            ['en', { label: t('editor.config.en'), value: 'en', description: t('editor.config.en') }],
            ['pt', { label: t('editor.config.pt'), value: 'pt', description: t('editor.config.pt') }],
            ['de', { label: t('editor.config.de'), value: 'de', description: t('editor.config.de') }],
        ])
    }, [t])
    
    return { languagesMap, languagesArray: Array.from(languagesMap.values()) }
}

export function LanguageSelect({ value, onChange, ...props }) {
    const [realValue, setRealValue] = useState(null);
    const { languagesArray, languagesMap } = useLanguageList();

    useEffect(() => {
        if (languagesMap.get(value)) {
            setRealValue(languagesMap.get(value))
        } else {
            setRealValue(null)
        }
    }, [languagesMap, value])

    const handleChange = (option) => {
        onChange(option?.value || null, option)
    }

    return <Select 
        // components={{ Option:  JurisdictionOption }}
        options={languagesArray}
        styles={reactSelectStyles}
        value={realValue}
        onChange={handleChange}
        {...props}
    />
}